export default "__VITE_ASSET__DShvFgeA__"